import { useState } from 'react';

export type ExclusionType = 'sessions' | 'classes' | 'events' | 'parents';

export function useLateFeesSettings() {
  const [feeType, setFeeType] = useState<string>('fixed');
  const [feeAmount, setFeeAmount] = useState<string>('25');
  const [interestRate, setInterestRate] = useState<string>('5');
  const [gracePeriod, setGracePeriod] = useState<string>('7');

  const [exclusions, setExclusions] = useState<
    Record<ExclusionType, Array<string>>
  >({
    sessions: [],
    classes: [],
    events: [],
    parents: [],
  });

  const updateExclusions = (type: ExclusionType, values: Array<string>) => {
    setExclusions((prev) => ({
      ...prev,
      [type]: values,
    }));
  };

  const handleSave = () => {
    // Handle save logic here
    console.log({
      feeType,
      feeAmount: feeType === 'fixed' ? feeAmount : interestRate,
      gracePeriod,
      exclusions,
    });
  };

  return {
    feeType,
    setFeeType,
    feeAmount,
    setFeeAmount,
    interestRate,
    setInterestRate,
    gracePeriod,
    setGracePeriod,
    exclusions,
    updateExclusions,
    handleSave,
  };
}
